import type {
  CreateYearResponseDto,
  GetYearsResponseDto,
  RemoveYearResponseDto,
  UpdateYearRequestDto,
  YearDto,
} from 'shared/dtos/years.dto';

import { ApiService } from './api.service';

export default class YearsService extends ApiService {
  public getYears = async (): Promise<GetYearsResponseDto> => {
    return await this.get('/years/');
  };

  public createYear = async (): Promise<CreateYearResponseDto> => {
    return await this.post('/years/', {});
  };

  public updateYear = async (
    id: number,
    data: UpdateYearRequestDto,
  ): Promise<YearDto> => {
    return await this.put(`/years/${id}`, data);
  };

  public removeYear = async (id: number): Promise<RemoveYearResponseDto> => {
    return await this.remove(`/years/${id}`);
  };
}
